import * as React from "react";
import Svg, { G, Circle, Path, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */

function SvgComponent(props) {
  return (
    <Svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G filter="url(#filter0_d_11633_1105)">
        <Circle cx={20} cy={18} r={16} fill="#fff" />
      </G>
      <Path
        d="M11.572 18.954l.073-.078c.23-.245.507-.416.803-.526v-6.48c0-1.031.833-1.87 1.856-1.87h7.682c1.023 0 1.855.838 1.855 1.87v5.209c.173.088.342.183.503.293l.58.397v-.018c0-.845.681-1.532 1.52-1.532h1.605A1.96 1.96 0 0130 18.184v5.85A1.96 1.96 0 0128.05 26h-1.607a1.523 1.523 0 01-1.512-1.453l-3.957 1.006a4.544 4.544 0 01-2.148.024l-3.26-.753a4.575 4.575 0 01-2.15-1.171l-1.772-1.715a2.137 2.137 0 01-.072-2.984zm14.499 5.514c0 .207.167.375.372.375h1.606a.807.807 0 00.803-.809v-5.85a.807.807 0 00-.803-.81h-1.606a.374.374 0 00-.372.376v6.718zm-6.827-13.311h-2.195v1.847h2.195v-1.847zm3.45.712a.711.711 0 00-.709-.713h-1.594v2.193c0 .447-.36.81-.805.81h-2.881a.808.808 0 01-.804-.81v-2.192h-1.598c-.39 0-.707.32-.707.713v6.39c.252.052.499.148.726.297l2.012 1.321a2.102 2.102 0 01-.072-.521c0-.997.703-1.869 1.672-2.075l2.888-.61a4.553 4.553 0 011.871 0V11.87zm-10.255 9.235l1.772 1.715a3.436 3.436 0 001.613.878l3.259.754c.528.12 1.084.114 1.61-.018l4.23-1.076v-4.188l-1.225-.84a3.432 3.432 0 00-2.64-.525l-2.888.611a.966.966 0 00-.76.942.96.96 0 00.957.963h1.992c.316 0 .573.26.573.579 0 .319-.256.578-.573.578H17.29c-.409 0-.806-.12-1.149-.344l-2.446-1.607a.95.95 0 00-1.216.146l-.074.077a.97.97 0 00.033 1.355z"
        fill="#000"
      />
      <G stroke="#FF2E00" strokeWidth={2} strokeLinecap="round">
        <Path d="M20 8l6 6M26 8l-6 6" />
      </G>
      <Defs />
    </Svg>
  );
}

export default SvgComponent;
